import { LayoutDashboard, UserPlus, Stethoscope, BedDouble, Calendar, ArrowRightLeft, FileSpreadsheet, BarChart3, Settings } from 'lucide-react';
import Container from '../../common/Container';

interface ModuleNavProps {
  activeModule: string;
  onSelectModule: (id: string) => void;
}

export const moduleList = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'patient-registration', label: 'Patient Registration', icon: UserPlus },
  { id: 'opd', label: 'OPD Services', icon: Stethoscope },
  { id: 'ipd', label: 'IPD Care', icon: BedDouble },
  { id: 'appointment', label: 'Appointments', icon: Calendar },
  { id: 'atd', label: 'Bed Mgmt (ATD)', icon: ArrowRightLeft },
  { id: 'discharge', label: 'Discharge Summary', icon: FileSpreadsheet },
  { id: 'reports', label: 'Reports & Analytics', icon: BarChart3 },
  { id: 'admin', label: 'Admin Panel', icon: Settings },
];

export const ModuleNav: React.FC<ModuleNavProps> = ({ activeModule, onSelectModule }) => {
  return (
    <div className="sticky top-[69px] z-40 bg-white/90 backdrop-blur-md border-b border-slate-200/80 py-3 shadow-sm">
      <Container>
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar scroll-smooth py-1">
          <span className="text-xs font-bold uppercase tracking-wider text-slate-400 whitespace-nowrap mr-2 hidden sm:inline-block">
            Quick Jump:
          </span>
          {moduleList.map((mod) => {
            const Icon = mod.icon;
            const isActive = activeModule === mod.id;
            return (
              <button
                key={mod.id}
                onClick={() => onSelectModule(mod.id)}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs md:text-sm font-semibold whitespace-nowrap transition-all duration-200 ${
                  isActive
                    ? 'bg-[#0D7893] text-white shadow-md shadow-[#0D7893]/25 scale-105'
                    : 'bg-slate-100 text-slate-700 hover:bg-[#0D7893]/10 hover:text-[#0D7893]'
                }`}
              >
                <Icon className={`w-4 h-4 ${isActive ? 'text-white' : 'text-[#0D7893]'}`} />
                <span>{mod.label}</span>
              </button>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ModuleNav;
